// Shared x-extent bus for synchronising all chart x-axes.
// Subscribers registered *after* a publish immediately receive the current value,
// so mount order doesn't matter.

let _current = null;
const _subs = new Set();

export function publishExtent(xMin, xMax) {
  _current = [xMin, xMax];
  _subs.forEach(fn => fn(_current));
}

export function clearExtent() {
  _current = null;
}

export function subscribeExtent(fn) {
  _subs.add(fn);
  if (_current) fn(_current);
  return () => _subs.delete(fn);
}
